export default {
  newRecipe: 'Nová receptúra',
  protectedTooltip: 'Túto receptúru nie je možné zmeniť, pretože je chránená',
};
